import type { Calibration } from '../geo/types';

/**
 * Known image placements. Startland's painted Map-4K.png (1665×945) was drawn for an older 3×2 chunk
 * grid; the best silhouette fit against the real terrain (measured 2026-09-25, IoU 0.91) is
 *   x = -724 + 0.8745·px,  z = 480 - 1.0063·py
 * i.e. the painting is ~15 % too wide. Refine with control points in the calibration panel.
 */
export const CALIBRATION_PRESETS: {
  id: string;
  mapSlug: string;
  widthPx: number;
  heightPx: number;
  affine: Calibration['affine'];
}[] = [
  {
    id: 'startland_painted_2026_09',
    mapSlug: 'startland',
    widthPx: 1665,
    heightPx: 945,
    affine: [0.8745, 0, -724, 0, -1.0063, 480],
  },
];
